var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3066_8843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8826 24.5H6.10642C2.72403 24.5 -0.0117188 21.7642 -0.0117188 18.3818V6.60568C-0.0117188 3.2233 2.72403 0.487549 6.10642 0.487549H17.8826C21.265 0.499984 24.0007 3.23574 24.0007 6.61812V18.3943C24.0007 21.7642 21.265 24.5 17.8826 24.5Z",
    fill: "#1EC677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7971 19.588C15.2219 19.588 16.9504 18.6678 17.9701 17.8968V14.5517C16.4655 15.7455 14.6872 16.4294 13.1204 16.4294C10.6085 16.4294 8.84267 14.7009 8.84267 12.2139C8.84267 9.85117 10.4468 8.20972 12.7349 8.20972C13.481 8.20972 14.1276 8.39625 14.8116 8.59521C15.5204 8.79417 16.2541 9.01801 17.137 9.01801C17.4106 9.01801 17.6841 8.99314 17.9577 8.95583V5.77241C17.7214 5.79728 17.51 5.80972 17.2738 5.80972C16.4779 5.80972 15.7691 5.6605 15.0105 5.49884C14.2147 5.32475 13.4064 5.16309 12.4489 5.16309C10.5339 5.16309 8.76806 5.83459 7.46236 7.07811C6.08205 8.39625 5.33594 10.2367 5.33594 12.3755C5.34837 16.6284 8.40744 19.588 12.7971 19.588Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3066_8843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChime);
export default __webpack_public_path__ + "static/media/Chime.92b924e792827064bcf5eb71616e785e.svg";
export { ForwardRef as ReactComponent };